<script>
import { mapActions, mapMutations } from "vuex";
import { defaultHandle } from "@/utils";

export default {
  props: {
    // ID for the modal element, to be used with v-b-modal.the-id
    modalId: {
      type: String,
      default: "create-team-modal",
    },
  },

  data() {
    return {
      // The name of the team to create
      name: "",

      // The handle of the team to create
      handle: "",
    };
  },

  watch: {
    // When the name changes update the handle to be the default handle
    name(value, old) {
      if (this.handle === "" || this.handle === defaultHandle(old)) {
        this.handle = defaultHandle(value);
      }
    },
  },

  methods: {
    // Hide the modal
    hide() {
      this.$refs.modal.hide();
    },

    // Create team given the form inputs
    async submit() {
      const team = await this.postTeam({
        name: this.name,
        handle: this.handle,
      });

      // If created successfully, then redirect to team page
      if (team != null) {
        this.name = "";
        this.handle = "";
        await this.getAccountRoles();
        this.setActiveTeamId(team.id);
        this.hide();
        if (this.$route.name != "teamGeneral") {
          await this.$router.push("/team");
        }
      }
    },

    // Mapped state actions
    ...mapActions(["postTeam", "getAccountRoles"]),
    ...mapMutations(["setActiveTeamId"]),
  },
};
</script>

<template>
  <b-modal
    ref="modal"
    :id="modalId"
    title="Create a Team"
    button-size="sm"
    hide-header-close
  >
    <p>
      Teams are used for organizing people around the management of miner
      deployments. To organize workers within a team,
      <b-link @click="hide" to="/groups/create">create a group</b-link>
      instead.
      <b-link @click="hide" to="/help/faq#group-vs-team">Learn more</b-link>
    </p>
    <b-form id="create-team-form" @submit.stop.prevent="submit">
      <b-form-group id="team-name-group" label="Name" label-for="team-name">
        <b-form-input
          required
          id="team-name"
          v-model="name"
          placeholder="Name"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        id="team-handle-group"
        label="Handle"
        label-for="team-handle"
      >
        <input
          ref="handleInput"
          required
          id="team-handle"
          v-model="handle"
          placeholder="Handle"
          pattern="[a-z,0-9]([a-z,0-9]|(-[a-z,0-9]))*"
          minlength="3"
          maxlength="64"
          autocomplete="off"
          class="form-control"
        />

        <small class="form-text text-muted">
          The team's handle will appear in worker names, like
          <b>my-team.a9-001</b>
          .
        </small>
      </b-form-group>
    </b-form>
    <template #modal-footer>
      <div class="float-right">
        <b-button class="mr-3" variant="light" @click="hide">Cancel</b-button>
        <b-button form="create-team-form" type="submit" variant="success">
          Create Team
        </b-button>
      </div>
    </template>
  </b-modal>
</template>
